if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}

(function () {
  if (window.__fairwinProductCvrFallbackLoaded) return;

  window.__fairwinProductCvrFallbackLoaded = true;

  const scriptSrc = document.currentScript?.src || '';
  const boosterSrc = scriptSrc ? scriptSrc.replace(/product-form\.js(?:\?.*)?$/, 'fairwin-cvr-boosters.js') : '';

  const ensureFallbackStyles = () => {
    if (document.getElementById('fairwin-cvr-fallback-style')) return;

    const style = document.createElement('style');
    style.id = 'fairwin-cvr-fallback-style';
    style.textContent = `
      .fairwin-checkout-promises{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:.7rem;margin:1.2rem 0}
      .fairwin-checkout-promises span{display:flex;gap:.55rem;align-items:center;min-height:3.6rem;padding:.75rem .9rem;border:1px solid rgba(31,28,23,.1);border-radius:999px;background:linear-gradient(135deg,rgba(139,122,79,.1),rgba(255,255,255,.9));font-size:1.15rem;font-weight:700;line-height:1.2}
      .fairwin-checkout-promises span:before{content:"";flex:0 0 .62rem;width:.62rem;height:.62rem;border-radius:50%;background:#8b7a4f;box-shadow:0 0 0 .32rem rgba(139,122,79,.12)}
      .fairwin-size-assistant{margin:1.2rem 0;padding:1.4rem;border:1px solid rgba(31,28,23,.1);border-radius:1.6rem;background:linear-gradient(135deg,rgba(255,255,255,.84),rgba(246,241,229,.82));box-shadow:0 1.2rem 3rem rgba(31,28,23,.06)}
      .fairwin-size-assistant__header{display:grid;gap:.35rem;margin-bottom:1rem}
      .fairwin-size-assistant__header span{width:fit-content;color:#6b5b36;font-size:1.05rem;font-weight:800;letter-spacing:.12em;text-transform:uppercase}
      .fairwin-size-assistant__header strong{font-size:1.6rem;line-height:1.2}
      .fairwin-size-assistant__control{display:grid;gap:.55rem}
      .fairwin-size-assistant__control label{font-size:1.15rem;font-weight:700;opacity:.68}
      .fairwin-size-assistant__input-row{display:grid;grid-template-columns:minmax(0,1fr) auto;align-items:center;overflow:hidden;border:1px solid rgba(31,28,23,.16);border-radius:1.2rem;background:rgba(255,255,255,.78)}
      .fairwin-size-assistant__input-row input{width:100%;min-height:4.6rem;padding:0 1.2rem;border:0;background:transparent;font-size:1.6rem}
      .fairwin-size-assistant__input-row span{padding-right:1.2rem;font-size:1.25rem;font-weight:800;opacity:.58}
      .fairwin-size-assistant__chips{display:flex;flex-wrap:wrap;gap:.6rem;margin-top:.9rem}
      .fairwin-size-assistant__chips button{min-height:3.4rem;min-width:5rem;border:1px solid rgba(31,28,23,.14);border-radius:999px;background:rgba(255,255,255,.72);cursor:pointer;font-weight:800}
      .fairwin-size-assistant__result{margin:1rem 0 0;font-size:1.25rem;line-height:1.45;opacity:.72}
      @media(max-width:420px){.fairwin-checkout-promises{grid-template-columns:1fr}}
    `;
    document.head.appendChild(style);
  };

  const ensureProductModules = () => {
    const productForm = document.querySelector('product-form form[action*="/cart/add"]');
    const buttonGroup = productForm?.querySelector('.product-form__buttons');

    if (!productForm || !buttonGroup) return;

    ensureFallbackStyles();

    if (!productForm.querySelector('[data-fairwin-checkout-promises]')) {
      buttonGroup.insertAdjacentHTML(
        'beforebegin',
        `<div class="fairwin-checkout-promises fairwin-checkout-promises--product" data-fairwin-checkout-promises>
          <span>60-day fit guarantee</span>
          <span>Secure checkout</span>
          <span>Fast shipping support</span>
          <span>2nd belt 30% off</span>
        </div>`
      );
    }

    if (!productForm.querySelector('[data-fairwin-size-assistant]')) {
      buttonGroup.insertAdjacentHTML(
        'afterend',
        `<div class="fairwin-size-assistant fairwin-size-assistant--product" data-fairwin-size-assistant>
          <div class="fairwin-size-assistant__header">
            <span>10-second fit check</span>
            <strong>Jeans waist -> FAIRWIN size</strong>
          </div>
          <div class="fairwin-size-assistant__control">
            <label for="FairwinWaistInput-Fallback">Your jeans waist</label>
            <div class="fairwin-size-assistant__input-row">
              <input id="FairwinWaistInput-Fallback" type="number" min="28" max="54" step="1" inputmode="numeric" placeholder="Example: 36" data-fairwin-waist-input>
              <span>in</span>
            </div>
          </div>
          <div class="fairwin-size-assistant__chips" aria-label="Quick waist examples">
            <button type="button" data-fairwin-waist-chip="32">32</button>
            <button type="button" data-fairwin-waist-chip="36">36</button>
            <button type="button" data-fairwin-waist-chip="40">40</button>
            <button type="button" data-fairwin-waist-chip="44">44</button>
          </div>
          <p class="fairwin-size-assistant__result" data-fairwin-size-result>
            Enter your jeans waist to see the safest size. If you are between sizes, choose the larger range.
          </p>
        </div>`
      );
    }

    if (!window.__fairwinCvrBoostersLoaded && boosterSrc && !document.querySelector('script[src*="fairwin-cvr-boosters.js"]')) {
      const script = document.createElement('script');
      script.src = boosterSrc;
      script.defer = true;
      document.head.appendChild(script);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ensureProductModules);
  } else {
    ensureProductModules();
  }
})();
